import { useProvideService } from "@colescba/app-vue"
import { AANConsultasService } from "./aan-consultas.service"

export const requestedServices = [
  
    config =>
    useProvideService(
      { baseURL: config.VUE_APP_AANCONSULTAS_SERVICE_URL, ...config },
      'api',
      AANConsultasService,
    ),
    
    
    
]
